import React from "react";

const SplashScreen = ({ style }) => {
  return (
    <div className="page-loading" style={style}>
      <div className="lds-ripple">
        <div></div>
      </div>
      <h1>loading</h1>
    </div>
  );
};

export default SplashScreen;
